import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { addEntity } from 'actions/livefeed'
import Dropdown from 'components/common/dropdowncomponents/dropdown';
import DropdownItem from 'components/common/dropdowncomponents/dropdownitem';

const AddEntityButton = (props) => {
    const { slideCurrentIndex, livefeedSlides, editorView, dispatch } = props;

    const { lineState, logoState } = livefeedSlides.slice()[slideCurrentIndex]
    // -------------------------------- Adding functions ---------------------------
    const addEntityHandle = useCallback((e, type) => {
        dispatch(addEntity(e, type))
    }, [dispatch])

    return (
        <React.Fragment>
            <div data-tooltip="Add Text Box" className="add-text-dropdown-wrapper">
                <Dropdown
                    className="toolbar-dropdown"
                    noArrow={true}
                    header={
                        <div className={`justify-center dropdown-header-text ${editorView === true ? '' : 'dropdown-header-text_disable'}`} >
                            <span style={{ fontSize: 14 }}>Insert</span>
                            <i style={{ fontSize: "24px" }} className="material-icons">add</i>
                        </div>
                    }
                    toggleable={editorView}
                >
                    {!logoState.show &&
                        <DropdownItem >
                            <input style={{ display: "none" }} id="addLogo" type="file" onChange={(e) => addEntityHandle(e, "logo")} />
                            <label style={{ display: "block" }} className="cursor--pointer" htmlFor="addLogo">Logo</label>
                        </DropdownItem>
                    }
                    {lineState.show === false ?
                        <DropdownItem>
                            <div onClick={(e) => addEntityHandle(e, "line")}>Divider Line</div>
                        </DropdownItem>
                        :
                        null
                    }
                    <DropdownItem>
                        <div onClick={(e) => addEntityHandle(e, "textObj")}>Text Box</div>
                    </DropdownItem>

                </Dropdown>
            </div>
        </React.Fragment>
    );
}

AddEntityButton.propTypes = {
    dispatch: PropTypes.func.isRequired,
    livefeedSlides: PropTypes.array.isRequired, // array with 1 object is considered to be a template.
    editorView: PropTypes.bool.isRequired,
    slideCurrentIndex: PropTypes.number.isRequired
}
export default AddEntityButton;



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/ToolbarContainer/ToolbarOptions/AddEntityButton.jsx